import type { Component, Entity2D } from '../../odie';

import { AndroidBlockProps, CountBlockOptionDef } from '../defs/block';
import { AndroidBlockView } from '../views/blocks/AndroidBlockView';

// types
//-----------------------------------------------------------------------------
export type AndroidBlockComponentOptions = {
  props: AndroidBlockProps;
  option?: number;
};

/*
    android block component
*/
export class AndroidBlockComponent implements Component {
  // constants
  //-------------------------------------------------------------------------
  public static readonly NAME = 'blockAndroid';

  // fields
  //-------------------------------------------------------------------------
  // injected
  public entity!: Entity2D;
  // scene
  public view!: AndroidBlockView;

  // properties
  //-------------------------------------------------------------------------
  private props!: AndroidBlockProps;
  // count
  public get count(): number {
    return this.view.count;
  }

  public set count(value: number) {
    // update view
    this.view.count = value;
  }

  // impl
  //-------------------------------------------------------------------------
  public init(options: AndroidBlockComponentOptions): void {
    // get option def
    const optionDef = options.props.options?.[
      options.option || 0
    ] as CountBlockOptionDef;

    this.props = options.props;

    // create view
    this.view = new AndroidBlockView(options.props);

    // set initial count
    this.count = optionDef.count;

    // Set the getGameplayState retrieval function
    this.entity.c.block.getGameplayState = () => this.getGameplayState();
  }

  public getGameplayState(): number {
    const options = this.props.options as CountBlockOptionDef[];
    return options.findIndex((opt) => {
      return opt.count === this.view.count;
    });
  }
}
